import { useEffect, useRef, useState } from "react";
import {
  ensureTelegramWidgetHost,
  isTelegramWidgetLoaded,
  parkTelegramWidgetHost,
} from "../../utils/telegramWidget";

export default function TelegramLogin({ onAuth }) {
  const containerRef = useRef(null);
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    setIsScriptLoaded(isTelegramWidgetLoaded());

    window.onTelegramAuth = (data) => {
      if (data.user) {
        onAuth?.(data);
      }
    };

    if (containerRef.current) {
      containerRef.current.innerHTML = "";
      containerRef.current.appendChild(
        ensureTelegramWidgetHost(() => {
          setIsScriptLoaded(true);
        }),
      );
    }

    return () => {
      parkTelegramWidgetHost();
      delete window.onTelegramAuth;
    };
  }, [onAuth]);

  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <button className="tg-auth-button" disabled={!isScriptLoaded}>
        Log in with Telegram
      </button>

      <div ref={containerRef} />
    </div>
  );
}
